/* @flow */

import * as React from 'react';

// Utils
import { isGroupTopic } from '@braindate/domain/lib/topic/util';
import { getBraindateTopic } from 'src/shared/domain/braindate/util/braindateUtil';
import { getConversationParticipants } from '@braindate/domain/lib/conversation/util';
import {
  getBraindateConversation,
  getBraindateSpotsLeft,
} from '@braindate/domain/lib/braindate/util';

// Components
import GroupAvatarQueue from 'src/shared/ui/component/image/GroupAvatarQueue';

// Type
import type { Braindate } from '@braindate/domain/lib/braindate/type';
import type { ExpressionOfGratitude } from '@braindate/domain/lib/expressionOfGratitude/type';
import BraindateCardAuthor from './BraindateCardAuthor';

type Props = {
  braindate: Braindate,
  expressionOfGratitude?: ExpressionOfGratitude,
  variant?: string,
  layoutClass?: string,
};

const BraindateCardAvatar = ({
  braindate,
  expressionOfGratitude,
  variant,
  layoutClass,
}: Props): React.Node => {
  const topic = getBraindateTopic(braindate);
  const isGroupBraindate = isGroupTopic(topic);

  if (isGroupBraindate) {
    return (
      <GroupAvatarQueue
        // $FlowIssue Will always be defined if it's a group braindate
        spots={getBraindateSpotsLeft(braindate)}
        participants={getConversationParticipants(
          getBraindateConversation(braindate),
        )}
        variant={variant}
        layoutClass={layoutClass}
      />
    );
  }

  return (
    <BraindateCardAuthor
      braindate={braindate}
      expressionOfGratitude={expressionOfGratitude}
    />
  );
};

export default React.memo<Props>(BraindateCardAvatar);
